import React from "react";

class InsightsTimeOfUseAnalysis extends React.Component {
    render() {
        return (
            <h1>Insights Time Of Use Analysis</h1>
        )
    }
};

export default InsightsTimeOfUseAnalysis;